import type { PaymentPart } from '@/api/transactions'
import { fromPaise } from '@/lib/splitMath'

export type PartRow = { accountId: string; amountPaise: number; edited: boolean }

/** Puts whatever the typed parts leave over into the last part the user hasn't typed into. */
export function fillRemainder(totalPaise: number, rows: PartRow[]): PartRow[] {
  const target = rows.map((r) => r.edited).lastIndexOf(false)
  if (target === -1) return rows
  const others = rows.reduce((s, r, i) => (i === target ? s : s + r.amountPaise), 0)
  return rows.map((r, i) =>
    i === target ? { ...r, amountPaise: Math.max(totalPaise - others, 0) } : r
  )
}

export function partsError(
  totalPaise: number,
  rows: PartRow[],
  format: (rupees: number) => string
): string | null {
  if (rows.some((r) => !r.accountId)) return 'Choose an account for each part'
  if (new Set(rows.map((r) => r.accountId)).size !== rows.length)
    return 'Choose a different account for each part'
  if (rows.some((r) => r.amountPaise <= 0)) return 'Each part must be more than ₹0'
  if (rows.reduce((s, r) => s + r.amountPaise, 0) !== totalPaise)
    return `The parts must add up to ${format(fromPaise(totalPaise))}`
  return null
}

export function toPayload(rows: PartRow[]): PaymentPart[] {
  return rows.map((r) => ({ financialAccountId: r.accountId, amount: fromPaise(r.amountPaise) }))
}
